<div class="config-page">

  <div class="page-head">

    <div>

      <div class="eyebrow">
        MODULE CONFIG
      </div>

      <h2>
        Menu Master
      </h2>

      <p>
        Create parent menus, child menus and application routes.
      </p>

    </div>


    <div class="head-actions">

      <button
        class="btn-light-custom"
        type="button"
        (click)="loadMenus()"
      >
        <i class="bi bi-arrow-clockwise"></i>
        Refresh
      </button>


      <button
        class="btn-primary-custom"
        type="button"
        (click)="openCreate()"
      >
        <i class="bi bi-plus-lg"></i>
        Add Menu
      </button>

    </div>

  </div>


  <div
    class="form-card"
    *ngIf="showForm"
  >

    <div class="card-title-row">

      <div>

        <h5>
          {{
            form.menuId > 0
              ? "Edit Menu"
              : "Create Menu"
          }}
        </h5>

        <p>
          Configure menu hierarchy and route.
        </p>

      </div>

    </div>


    <div class="row g-3">

      <div class="col-md-4">

        <label>
          Menu Name *
        </label>

        <input
          class="form-control"
          [(ngModel)]="form.menuName"
          (blur)="menuNameBlur()"
        />

      </div>


      <div class="col-md-4">

        <label>
          Menu Code *
        </label>

        <input
          class="form-control"
          [(ngModel)]="form.menuCode"
        />

      </div>


      <div class="col-md-4">

        <label>
          Parent Menu
        </label>

        <select
          class="form-select"
          [(ngModel)]="form.parentMenuId"
        >

          <option [ngValue]="0">
            Root / Parent Menu
          </option>

          <option
            *ngFor="
              let parent of parentMenus
            "
            [ngValue]="parent.menuId"
          >
            {{ parent.menuName }}
          </option>

        </select>

      </div>


      <div class="col-md-3">

        <label>
          Display Order
        </label>

        <input
          type="number"
          min="1"
          class="form-control"
          [(ngModel)]="form.displayOrder"
        />

        <small class="text-muted">
          Auto-filled using the next available order. You can change it.
        </small>

      </div>


      <div class="col-md-5">

        <label>
          Template / Route Path
        </label>

        <input
          class="form-control"
          [(ngModel)]="form.templatePath"
          placeholder="/module-name/page"
        />

      </div>


      <div class="col-md-4">

        <label>
          Icon
        </label>

        <input
          class="form-control"
          [(ngModel)]="form.menuIconUrl"
          placeholder="bi bi-grid"
        />

      </div>


      <div class="col-md-4">

        <label>
          Module Name
        </label>

        <select
          class="form-select"
          [(ngModel)]="form.moduleName"
          (ngModelChange)="onModuleNameChange()"
        >

          <option
            *ngFor="
              let module of moduleOptions
            "
            [value]="module"
          >
            {{
              module ||
              "Global / Common"
            }}
          </option>

        </select>

      </div>


      <div class="col-md-4">

        <label>
          {{ moduleEntityLabel }}
          <span class="text-muted">
            Optional
          </span>
        </label>

        <select
          class="form-select"
          [(ngModel)]="form.moduleId"
          [disabled]="
            !requiresModuleEntity ||
            loadingModuleEntities
          "
        >

          <option [ngValue]="null">
            {{
              loadingModuleEntities
                ? "Loading..."
                : moduleEntityPlaceholder
            }}
          </option>

          <option
            *ngFor="
              let entity of moduleEntities
            "
            [ngValue]="entity.id"
          >
            {{ entity.name }}
          </option>

        </select>

      </div>


      <div
        class="col-md-4"
        *ngIf="form.menuId > 0"
      >

        <label>
          Status
        </label>

        <select
          class="form-select"
          [(ngModel)]="form.isActive"
        >

          <option [ngValue]="1">
            Active
          </option>

          <option [ngValue]="0">
            Inactive
          </option>

        </select>

      </div>


      <div
        class="col-md-4"
        *ngIf="form.menuId > 0"
      >

        <label>
          Default Child
        </label>

        <select
          class="form-select"
          [(ngModel)]="
            form.defaultChildMenuId
          "
        >

          <option [ngValue]="0">
            No Default Child
          </option>

          <option
            *ngFor="
              let child of defaultChildMenus
            "
            [ngValue]="child.menuId"
          >
            {{ child.menuName }}
          </option>

        </select>

      </div>


      <div class="col-12">

        <label>
          Description
        </label>

        <textarea
          class="form-control"
          rows="3"
          [(ngModel)]="form.menuDesc"
        ></textarea>

      </div>

    </div>


    <div class="form-footer">

      <button
        type="button"
        class="btn-light-custom"
        (click)="cancelForm()"
      >
        Cancel
      </button>


      <button
        type="button"
        class="btn-primary-custom"
        [disabled]="
          saving ||
          loadingModuleEntities
        "
        (click)="saveMenu()"
      >

        {{
          saving
            ? "Saving..."
            : form.menuId > 0
              ? "Update Menu"
              : "Create Menu"
        }}

      </button>

    </div>

  </div>


  <div class="data-card">

    <div class="table-toolbar">

      <div>

        <h5>
          Menu Structure
        </h5>

        <small>
          {{ filteredMenus.length }}
          menu(s)
        </small>

      </div>


      <div class="toolbar-right">

        <select
          class="form-select small-select"
          [(ngModel)]="moduleFilter"
          (ngModelChange)="pageNo = 1"
        >

          <option value="">
            All Modules
          </option>

          <option value="School">
            School
          </option>

          <option value="Hospital">
            Hospital
          </option>

          <option value="Society">
            Society
          </option>

          <option value="Common">
            Common
          </option>

        </select>


        <div class="search-box">

          <i class="bi bi-search"></i>

          <input
            [(ngModel)]="searchText"
            (ngModelChange)="pageNo = 1"
            placeholder="Search menus..."
          />

        </div>

      </div>

    </div>


    <div
      class="loading-box"
      *ngIf="loading"
    >
      Loading menus...
    </div>


    <div
      class="table-responsive"
      *ngIf="!loading"
    >

      <table class="config-table">

        <thead>

          <tr>
            <th>Menu</th>
            <th>Parent</th>
            <th>Route</th>
            <th>Module</th>
            <th>Order</th>
            <th>Status</th>
            <th class="text-end">
              Actions
            </th>
          </tr>

        </thead>


        <tbody>

          <tr
            *ngFor="
              let menu of paginatedMenus
            "
          >

            <td>

              <strong>
                {{ menu.menuName }}
              </strong>

              <small>
                {{ menu.menuCode }}
              </small>

            </td>


            <td>
              {{
                getParentName(
                  menu.parentMenuId
                )
              }}
            </td>


            <td>

              <code>
                {{
                  menu.templatePath ||
                  "-"
                }}
              </code>

            </td>


            <td>
              {{
                menu.moduleName ||
                "Global"
              }}
            </td>


            <td>
              {{ menu.displayOrder }}
            </td>


            <td>

              <span
                class="status active"
                *ngIf="menu.isActive === 1"
              >
                Active
              </span>

              <span
                class="status inactive"
                *ngIf="menu.isActive !== 1"
              >
                Inactive
              </span>

            </td>


            <td class="text-end">

              <button
                class="icon-btn edit"
                type="button"
                (click)="editMenu(menu)"
              >
                <i class="bi bi-pencil"></i>
              </button>


              <button
                class="icon-btn delete"
                type="button"
                (click)="deleteMenu(menu)"
              >
                <i class="bi bi-trash"></i>
              </button>

            </td>

          </tr>


          <tr
            *ngIf="
              paginatedMenus.length === 0
            "
          >

            <td
              colspan="7"
              class="empty-cell"
            >
              No menus found.
            </td>

          </tr>

        </tbody>

      </table>

    </div>


    <div class="pagination-row">

      <span>
        Page {{ pageNo }}
        of {{ totalPages }}
      </span>


      <div>

        <button
          class="pagination-btn"
          [disabled]="pageNo === 1"
          (click)="previousPage()"
        >
          Previous
        </button>

        <button
          class="pagination-btn"
          [disabled]="
            pageNo === totalPages
          "
          (click)="nextPage()"
        >
          Next
        </button>

      </div>

    </div>

  </div>

</div>